import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { recognizeItems } from '../data/liikunta';
export function Recognize() {
  return <section className="w-full bg-slate-900 px-8 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-260" data-mp="30xq459r7icso">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12" data-id="element-261" data-mp="2w56rcf0cflox">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-5" data-id="element-262" data-mp="2r7wvohmd2dsn">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-263" data-mp="2m8bv62rjlxdt">
            Kender du det her?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-264" data-mp="2i5nl5rr3ekf9">
            Hvis du svarer ja til bare ét af spørgsmålene, er IDRÆT KLAR™ lavet til dig.
          </p>
          <a href="#inside" className="group mt-10 inline-flex items-center gap-2 font-serif text-2xl italic text-red-300 transition-colors duration-150 ease-out hover:text-stone-50" data-id="element-265" data-mp="2892cmwfv6r6o">
            Du fortjener en lettere vej
            <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-266" data-mp="6ih95yu6db8t" />
          </a>
        </div>

        <ul className="divide-y divide-white/10 border-y border-white/10 lg:col-span-7" data-id="element-267" data-mp="3nmfad9zwkyw0">
          {recognizeItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex gap-5 py-7 sm:gap-6" data-id="element-268" data-mp="39p8xfw1v1uep">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-white/15 text-red-300" data-id="element-269" data-mp="3emithujr94bi">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-270" data-mp="b5aerjkbqkl0" />
                </span>
                <div data-id="element-271" data-mp="b73cg9cylugv">
                  <h3 className="font-serif text-2xl leading-tight sm:text-3xl" data-id="element-272" data-mp="3sm1ormrgwl6e">{item.title}</h3>
                  <p className="mt-2 leading-relaxed text-stone-50/70" data-id="element-273" data-mp="1f7cstv85waj">{item.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}